import { useState } from 'react';
import Popper from '@mui/material/Popper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

export function RenderCellExpand(params: CellParams) {
  return (
    <CellExpand
      value={params.value ? params.value.toString() : ""}
      width={params.colDef.width}
    />
  );
}

export function CustomCellRenderer({ value, field, cellClassName }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpenPopper = (event) => {
    setAnchorEl(event.currentTarget);
    setTimeout(() => {
      handleClosePopper();
    }, 10000);
  };

  const handleClosePopper = () => {
    setAnchorEl(null);
    setIsPopperOpen(false);
  };

  const isPopperOpen = Boolean(anchorEl);

  return (
    <div>
      {value && value.length > 50 ? (
      <div className={cellClassName}>
        <div onClick={handleOpenPopper} style={{ cursor: 'pointer' }}>
          {value}
        </div>
        <Popper
          open={isPopperOpen}
          anchorEl={anchorEl}
          placement="bottom-start"
          disablePortal={false}
          onClose={handleClosePopper}
          modifiers={[
            {
              name: 'flip',
              enabled: true,
              options: {
                altBoundary: true,
                flipVariations: true,
              },
            },
            {
              name: 'preventOverflow',
              enabled: true,
              options: {
                altAxis: true,
                tetherOffset: 0,
              },
            },
          ]}
        >
        <div
          style={{
            height: '100%',
            width: '400px',
            padding: '8px', 
            background: 'rgb(17, 24, 39)', 
            color:"white"
          }}
        >
          <Typography variant="body2">{value}</Typography>
        </div>
      </Popper>
    </div>
      ) : (
      value
      )}
    </div>
  );
}